import { render } from "./AuthorizedContactList.vue?vue&type=template&id=6de6797e&ts=true"
import script from "./AuthorizedContactList.ts?vue&type=script&lang=ts&external"
export * from "./AuthorizedContactList.ts?vue&type=script&lang=ts&external"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__